/** ----- buildHeaders.js -----
 *  File: buildHeaders.js
 *
 *  Purpose: providing helper functions to set headers for api requests
 *
 *-----------------------------*/
import { ethers } from "ethers";
import Cookies from "universal-cookie";
import { getEnv } from "./env";

const cookieHandler = new Cookies();
const isServer = !(
  typeof window !== "undefined" &&
  window.document &&
  window.document.createElement
);
const REACT_APP_PROJECT_ID = getEnv("REACT_APP_PROJECT_ID");

async function buildHeaders(language = null) {
  if (REACT_APP_PROJECT_ID === "UNKOWN") {
    return {};
  }
  let creatorToken = cookieHandler.get("creator-token");
  let walletToken = cookieHandler.get("wallet-token");
  let creatorUid = cookieHandler.get("creator-uid");
  let walletUid = cookieHandler.get("wallet-uid");
  let signer = null;
  if (!isServer) {
    try {
      signer = window.account;
      if (!signer) {
        if (window.solana && window.solana.publicKey) {
          // Solana wallet is connected
          signer = window.solana.publicKey.toString();
        } else {
          // TODO: Verify that we can use this provider to get the signer. If not, we need to use the provider from the web3react.
          const provider = new ethers.providers.Web3Provider(window.ethereum);
          const walletSigner = await provider.getSigner();
          signer = await walletSigner.getAddress();
        }
      }
    } catch (e) {
      console.error("Account missing missing", e);
    }
  }
  const headers = {
    "Content-Type": "application/json",
  };
  if (creatorToken && creatorUid === signer)
    headers["creator-token"] = creatorToken;
  if (walletToken && walletUid === signer) headers["wallet-token"] = walletToken;
  if (signer) headers["uid"] = signer;
  let requestLanguage = language;
  if (!isServer) {
    const splitUrl = window.location.pathname.split("/");
    if (splitUrl.length > 1 && splitUrl[1] && splitUrl[1].length === 2) {
      requestLanguage = splitUrl[1];
    }
  }

  if (requestLanguage) headers["language"] = requestLanguage;
  return headers;
}

export default buildHeaders;
